import React, { useMemo } from "react";
import { GreenEllipse, RedEllipse, RightArrowIcon } from "../../../Icons";

const Card = ({ card }) => {
  const { id, status, name, card_brand, card_provider, card_number } = card || {};

  // ✅ Compute image source using useMemo to avoid re-evaluating on each render
  const imageSrc = useMemo(() => {
    const provider = card_provider?.toLowerCase();
    const brand = card_brand?.toLowerCase();

    if (status !== "Active") {
      return provider === "mm"
        ? "assets/logos/match-move-othercard-bg.png"
        : provider === "em"
        ? "assets/logos/emoney-card.png"
        : "assets/logos/blockedOtherCardBg.png";
    }

    if (brand === "visa") return "assets/logos/add-card-visa.png";
    if (provider === "em") return "assets/logos/emoney-card.png";
    return "assets/logos/match-move-othercard-bg.png";
  }, [status, card_brand, card_provider]);

  // ✅ Pre-compute active state and styles
  const isActive = status === "Active";
  const statusIcon = isActive ? <GreenEllipse /> : <RedEllipse />;
  const statusClasses = isActive ? "" : "bg-zinc-400 opacity-60";

  return (
    <div
      key={id}
      className="othercard-card-wrapper">
      {/* Left section */}
      <div className="flex items-center">
        <img
          src={imageSrc}
          alt="Card"
          className={`rounded-md ${statusClasses}`}
        />
        <div className="ml-3">
          <p className="othercard-title">
            {name}
          </p>
          <div className="flex items-center justify-center space-x-2">
            {statusIcon}
            <p className="othercard-status">
              {status} | ·· {card_number?.slice(-4)}
            </p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center text-text-primary text-sm font-medium leading-tight tracking-tight">
        <RightArrowIcon />
      </div>
    </div>
  );
};

export default React.memo(Card);
